import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useContext, useState } from 'react';
type NavigationOverrideContextType = {
  isNavigationOverridden: boolean;
  setNavigationOverridden: (value: boolean) => void;
};
const NavigationOverrideContext = createContext<NavigationOverrideContextType | null>(null);
export const NavigationOverrideProvider = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [isNavigationOverridden, setNavigationOverridden] = useState(false);
  let t1;
  if ($[0] !== isNavigationOverridden) {
    t1 = {
      isNavigationOverridden,
      setNavigationOverridden
    };
    $[0] = isNavigationOverridden;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <NavigationOverrideContext.Provider value={t1}>{children}</NavigationOverrideContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const useNavigationOverride = () => {
  const context = useContext(NavigationOverrideContext);
  if (!context) {
    throw new Error("useNavigationOverride must be used within NavigationOverrideProvider");
  }
  return context;
};

/** Read-only variant for callers that also run outside the provider, like the root error boundary. */
export const useIsNavigationOverridden = () => {
  return useContext(NavigationOverrideContext)?.isNavigationOverridden ?? false;
};